/*
    node_js
    2/26/2021 8:27 AM
    by Oleksandr
*/

import CWP from "./cwp/CWP";

const CNTL = () => {
    return (
        <>
            <CWP isCon={true}/>
        </>
    )
}

export default CNTL;